import { storage } from '@doxyme/ui/utils';
import { StorageKeys } from '../../../shared/constants/storageKeys';

export type SortOrder = 'asc' | 'desc' | 'room';

export function getPatientQueueSortOrderFromSession(): SortOrder | undefined {
  return storage.getItem<SortOrder>(StorageKeys.DashboardWaitingRoomSortOrder);
}

export function setPatientQueueSortOrderToSession(order: SortOrder): void {
  storage.setItem(StorageKeys.DashboardWaitingRoomSortOrder, order);
}
